module.exports = __webpack_public_path__ + "static/arin-miftah-favicon-1910bfd905debf974c819fc4c43c4c8e.png";